import { AlignLayoutGroupCenter } from '@/game/GameComponents/PhaserGame/Utils/PhaserLayout/LayoutGroupUtils';
import { CardLayoutGroupData } from '@/game/GameComponents/PhaserGame/Utils/PhaserLayout/SequencedMinigameCardLayoutGroup';
import MinigameCardSlot from '@/game/prefabs/StudentGame/MinigameCardSlot';
import StudentGameCard from '@/game/prefabs/StudentGame/StudentGameCard';
import PlaceholderMinigameCard from '@/game/scenes/PlaceholderStudentGameCard';

export default class SlottedMinigameCardLayoutGroup {
  constructor(data: CardLayoutGroupData) {
    this.data = data;

    this.updateLayout();
  }

  cards: SlottedObject[] = [];
  isRealigning: boolean = false;
  rowCount: number = 1;
  rowHeight: number = 64;
  data: CardLayoutGroupData;
  /*
   * Currently unused, but may be useful in future.
   */
  insertCardAndPushAlong(card: StudentGameCard, index: number) {
    const { data } = this;
    let floatingCard = card;
    let tempCard = null;
    let shiftedCards = [];
    while (floatingCard && index < data.maxCards) {
      // Don't shift a card along more than 1 space.
      if (shiftedCards.indexOf(floatingCard) !== -1) return;
      shiftedCards.push(floatingCard);

      // Take the card out of the index we want to go into.
      if (this.cards[index] instanceof MinigameCardSlot) {
        this.removeSlot(index);
      }
      tempCard = this.cards[index];

      // Place the floating card down.
      this.cards[index] = floatingCard;

      // Float the temp card.
      if (tempCard instanceof StudentGameCard) floatingCard = tempCard;
      // Go to the next slot.
      index++;
    }
  }

  insertCardAndSwap(card: SlottedObject, index: number) {
    const existingCard = this.cards[index];
    let fromDropSite: undefined = undefined;
    //let fromIndex: number | undefined;
    if (card instanceof StudentGameCard) {
      //fromDropSite = card.origin?.dropSite;
      //fromIndex = card.origin?.index;
    } else if (card instanceof PlaceholderMinigameCard) {
      //fromDropSite = card.representingMinigameCard?.origin?.dropSite;
      //fromIndex = card.representingMinigameCard?.origin?.index;
    }

    if (existingCard instanceof StudentGameCard) {
      this.removeCard(existingCard);
      if (fromDropSite) {
        // fromDropSite.addCard(existingCard, fromIndex || 0);
      }
    }
  }

  pushCard(card: CardObject, realignmentOverride?: 'instant' | 'animated') {
    for (var i = 0; i < this.data.maxCards; i++) {
      if (this.cards[i] === null || this.cards[i] instanceof MinigameCardSlot) {
        this.addCard(card, i, realignmentOverride);
        return;
      }
    }
    console.error('no space to push card', card);
    return;
  }

  addCard(
    card: CardObject,
    index?: number,
    realignmentOverride?: 'instant' | 'animated',
  ): boolean {
    if (!card) return false;
    const { data } = this;
    const placeAtIndex = index !== undefined ? index : 0;

    card.scene.tweens.killTweensOf(card);

    const cardAtTarget = this.cards[placeAtIndex];
    if (cardAtTarget instanceof StudentGameCard) {
      console.error('Card already exists at index', placeAtIndex);
      return false;
    }

    this.setCardPositionForAdd(card);

    this.cards[placeAtIndex] = card;
    data.parent.add(card);
    data.parent.moveTo(card, placeAtIndex);
    this.updateLayout(realignmentOverride);
    return true;
  }

  // Removes the card and adds it to the root level scene.
  removeCard(card: SlottedObject) {
    if (!card) return;
    const { data } = this;
    const cardIndex = this.cards.indexOf(card);
    if (cardIndex === -1) {
      return;
    }
    card.scene.add.existing(card);
    this.cards[cardIndex] = null;
    const cardParentTransform = data.parent.getWorldTransformMatrix();
    card.setPosition(
      card.x + cardParentTransform.tx,
      card.y + cardParentTransform.ty,
    );
    this.updateLayout();
  }

  // Removes the card and fully destroys it.
  destroyCard(card: SlottedObject) {
    if (!card) return;
    const cardIndex = this.cards.indexOf(card);
    if (cardIndex === -1) {
      console.error('card', card, ' was not in drop site', this);
      return;
    }
    this.cards[cardIndex] = null;
    card.destroy();
  }

  moveCard(card: CardObject, newIndex: number) {
    const currentIndex = this.cards.indexOf(card);
    if (currentIndex === newIndex) {
      return;
    }
    if (currentIndex === -1) {
      console.error('Card not found in layout group');
      return;
    }

    // Swap the cards around.
    const cardAtIndex = this.cards[newIndex];
    if (cardAtIndex instanceof StudentGameCard) {
      this.cards[currentIndex] = cardAtIndex;
      this.data.parent.moveTo(cardAtIndex, currentIndex);
      if (cardAtIndex.origin) {
        cardAtIndex.origin = {
          ...cardAtIndex.origin,
          index: currentIndex,
        };
      }
    } else {
      this.cards[currentIndex] = null;
    }
    this.cards[newIndex] = card;
    this.data.parent.moveTo(card, newIndex);
    this.updateLayout();
  }

  removeSlot(index: number) {
    if (!(this.cards[index] instanceof MinigameCardSlot)) return;
    this.cards[index]?.destroy();
    this.cards[index] = null;
  }

  clearSlots() {
    // Destroys all the slots in the parent container,
    // regardless of whether or not they're in the layout group.
    let childrenToRemove: Phaser.GameObjects.GameObject[] = [];
    for (var i = 0; i < this.data.parent.list.length; i++) {
      const child = this.data.parent.list[i];
      if (child instanceof MinigameCardSlot) {
        const childIndex = this.cards.indexOf(child);
        if (childIndex !== -1) {
          this.cards[childIndex] = null;
        }
        childrenToRemove.push(child);
      }
    }

    childrenToRemove.forEach((child) => {
      this.data.parent.remove(child, true);
    });
  }

  createNewSlots() {
    // Creates new slots where there are no cards.

    for (var i = 0; i < this.data.maxCards; i++) {
      if (this.cards[i] === null) {
        const newSlot = new MinigameCardSlot(this.data.parent.scene, 0, 0);
        this.cards[i] = newSlot;
        this.data.parent.add(newSlot);
        this.data.parent.moveTo(newSlot, i);
      }
    }
  }

  updateLayout(_realignmentOverride?: 'instant' | 'animated') {
    const { cards, data } = this;

    //const realignmentType = realignmentOverride || data.realignmentType;

    // Delete all the old slots.
    this.clearSlots();

    // Create all the new slots.
    this.createNewSlots();

    // Reorder everything.

    for (var i = 0; i < this.data.maxCards; i++) {
      // Move cards to their correct sibling indices.
      try {
        const card = cards[i];
        if (card) {
          data.parent.moveTo(card, i);
        }
      } catch {}
    }

    AlignLayoutGroupCenter(this);
  }

  positionElement(
    card: Phaser.GameObjects.GameObject,
    x: number,
    y: number,
    realignmentTypeOverride?: 'instant' | 'animated',
  ) {
    if (!card) return;
    if (card instanceof MinigameCardSlot) {
      // Slots should never animate to their positions.
      card.setPosition(x, y);
    } else {
      if (card instanceof PlaceholderMinigameCard) {
        realignmentTypeOverride = 'instant';
      } else if (card instanceof StudentGameCard) {
        // Update the desired position of the card.
        // This is the value that's used when determining where cards are trying to be dropped.
        if (card.origin) {
          const worldTransform = this.data.parent.getWorldTransformMatrix();
          const localPos = worldTransform.transformPoint(x, y);
          card.origin = {
            ...card.origin,
            desiredPosition: { x: localPos.x, y: localPos.y },
          };
        }
      }
      const { data } = this;
      switch (realignmentTypeOverride || data.realignmentType) {
        case 'instant':
        default:
          (card as SlottedObject)?.setPosition(x, y);
          break;
        case 'animated':
          this.isRealigning = true;
          data.parent.scene.tweens.add({
            targets: card,
            x: x,
            y: y,
            duration: 300,
            ease: 'Cubic.easeOut',
            onComplete: () => {
              this.isRealigning = false;
            },
          });
      }
    }
  }

  setCardPositionForAdd(card: CardObject) {
    const { parent } = this.data;

    if (!card.parentContainer && card instanceof StudentGameCard) {
      const parentTransform = parent.getWorldTransformMatrix();
      card.setPosition(
        card.x - parentTransform.tx,
        card.y - parentTransform.ty,
      );
    }
  }

  stopRealignment() {
    this.isRealigning = false;
    this.cards.forEach((card) => {
      card?.scene.tweens.killTweensOf(card);
    });
  }

  getMinigameCards(): StudentGameCard[] {
    return this.cards.filter((card) => card instanceof StudentGameCard);
  }

  getCardCount() {
    return this.getMinigameCards().length;
  }

  isFull(): boolean {
    return this.getCardCount() === this.data.maxCards;
  }

  findCard(card: CardObject): CardObject | null {
    return this.cards.find((c) => c === card) as CardObject | null;
  }

  reset() {
    for (var i = 0; i < this.cards.length; i++) {
      this.cards[i]?.destroy();
    }
    this.cards = [];
    this.updateLayout();
  }

  setMaxCards(newMax: number) {
    const oldMax = this.data.maxCards;
    this.data.maxCards = newMax;
    for (var i = 0; i < this.data.maxCards; i++) {
      if (!this.cards[i]) {
        this.cards[i] = null;
      }
    }

    if (newMax !== oldMax) {
      // Shift all the cards down to the first empty index.
      for (var j = 0; j < this.cards.length; j++) {
        const firstEmptyIndex = this.cards.findIndex((card) => {
          return card === null || card instanceof MinigameCardSlot;
        });

        if (this.cards[j] instanceof StudentGameCard) {
          if (firstEmptyIndex !== -1 && firstEmptyIndex < this.data.maxCards) {
            this.moveCard(this.cards[j] as StudentGameCard, firstEmptyIndex);
          }
        }
      }
    }
    this.updateLayout();
  }

  getGlobalPositionFromIndex(index: number): Phaser.Math.Vector2 {
    const card = this.cards[index];
    if (card) {
      const cardPos = card.getWorldTransformMatrix();
      return new Phaser.Math.Vector2(cardPos.tx, cardPos.ty);
    }
    return new Phaser.Math.Vector2(0, 0);
  }
}

export type SlottedObject =
  | StudentGameCard
  | MinigameCardSlot
  | PlaceholderMinigameCard
  | null;

type CardObject = StudentGameCard | PlaceholderMinigameCard;
